<div class="info-card-grid" [class]="'variant-' + variant() + ' columns-' + columns()">
  @for (card of cards(); track card.title) {
    @if (variant() === 'card') {
      <div class="info-card">
        <div class="card-icon" [class]="card.iconColor || 'default'">
          <htx-icon [icon]="card.icon"></htx-icon>
        </div>
        <h4>{{ card.title }}</h4>
        <p>{{ card.description }}</p>
        @if (card.tags && card.tags.length > 0) {
          <div class="card-tags">
            @for (tag of card.tags; track tag) {
              <span class="tag">{{ tag }}</span>
            }
          </div>
        }
        @if (card.status) {
          <div class="card-status">
            <htx-icon icon="schedule"></htx-icon>
            {{ card.status }}
          </div>
        }
      </div>
    } @else {
      <div class="info-list-item">
        <div class="list-icon" [class]="card.iconColor || 'default'">
          <htx-icon [icon]="card.icon"></htx-icon>
        </div>
        <div class="list-content">
          <h4>{{ card.title }}</h4>
          <p>{{ card.description }}</p>
          @if (card.status) {
            <div class="card-status">
              <htx-icon icon="schedule"></htx-icon>
              {{ card.status }}
            </div>
          }
        </div>
      </div>
    }
  }
</div>
